export default {
	allowanceButtons: {
		gap: "10px",
		display: "flex",
		alignItems: "center",

		"@media(max-width: 767px)": {
			flexWrap: "wrap"
		},

		"& button": {
			width: "200px",
			height: "50px",
			color: "#fff",
			fontWeight: "600",
			border: "1px solid",
			borderRadius: "5px",
			cursor: "pointer",
			transition: "all .2s ease",

			"&:first-of-type": {
				background: "#7fc2ff",
				borderColor: "#7fc2ff"
			},

			"&:last-of-type": {
				background: "#857ef7",
				borderColor: "#857ef7"
			},

			"&:hover": {
				color: "#465578",
				background: "transparent"
			},

			"@media(max-width: 1024px)": {
				width: "165px",
				height: "40px",
				fontSize: "12px"
			},

			"@media(max-width: 450px)": {
				width: "100%"
			}
		}
	}
}
